// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { actions as StoresActions } from '../duck';
import Stores from '../components/Stores';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    locale: state.locale,
    stores: state.stores.stores,
    isFetchingStores: state.stores.isFetchingStores,
    pageCanAsk: state.stores.pageCanAsk,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...StoresActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Stores);



// WEBPACK FOOTER //
// ./src/modules/stores/containers/StoresContainer.js